import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Icon } from '@material-ui/core';
import '../NewChannelModal/NewChannelModal.css';

const Header = ({ closeModal, ...props }) => {
  return (
    <div className='new-channel-modal-header '>
      <IconButton onClick={closeModal}>
        <Icon>clear</Icon>
      </IconButton>
    </div>
  );
};

Header.propTypes = {
  closeModal: PropTypes.func
};

export default Header;
